import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_2 = { class: "mr-2 count" }
const _hoisted_3 = { class: "flex-fill text-truncate" }
const _hoisted_4 = {
  key: 2,
  class: "d-flex align-items-center"
}
const _hoisted_5 = { class: "pr-2" }
const _hoisted_6 = {
  class: "d-flex text-truncate",
  style: {"min-width":"0"}
}
const _hoisted_7 = { class: "mr-2" }

import {computed} from 'vue';
import OperatorApplicationTextareaSuggestInterface
    from "~/operatorApplication/vue/dialogs/dialog/suggestedTemplates/OperatorApplicationTextareaSuggestInterface";
import FontAwesomeIcon from "~/cabinet/vue/interface/icon/FontAwesomeIcon.vue";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import OperatorApplicationAutomaticTemplates
    from "~/operatorApplication/ts/service/dialog/OperatorApplicationAutomaticTemplates";
import StringHelper from "~/ts/library/StringHelper";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {__} from "~/ts/library/Translate";


const __default__ = {
    name: "OperatorApplicationSuggestedTemplate"
}

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    template: {},
    siteId: {},
    selected: { type: Boolean }
  },
  emits: ["reload", "select"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit;

let previewText = computed(() => {
    let result: string;
    if (props.template.template) {
        let template = props.template.template;
        result = (typeof template.text == "string" && template.text.trim().length > 0 ? template.text : template.html);
    } else {
        result = props.template.autoTemplate.text;
    }
    if (typeof result == "string") {
        result = StringHelper.stripBbCode(result).substring(0, 300);
    }
    return result;
});

async function removeAutoTemplate(text: string) {
    try {
        await ElConfirm(__("Вы уверены, что хотите удалить этот шаблон?"));

        let p: OperatorApplicationApi.ExcludeFromAutoTemplatesOpenApiModel = {
            siteId: props.siteId,
            text
        };
        (new OperatorApiRequest({
            url: "/messageTemplate/excludeFromAutoTemplates",
            p,
            silent: true,
            silentError: true
        })).send();
        OperatorApplicationAutomaticTemplates.removeAutoSuggestedTemplate(text);
        emits("reload");
    } catch (e) {
    }
}

let tooltipText = computed(() => {
    if (props.template.template) {
        return props.template.template.text;
    } else if (props.template.autoTemplate) {
        return props.template.autoTemplate.text;
    }
    return undefined;
});

return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _directive_on_native = _resolveDirective("on-native")!
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return _withDirectives((_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['text-truncate mb-1 text-muted suggest', __props.selected ? 'hover' : null]),
    onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(emits)('select', __props.template)))
  }, [
    (__props.template.autoTemplate)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(__props.template.autoTemplate.count), 1),
          _createElementVNode("a", _hoisted_3, _toDisplayString(_unref(previewText)), 1),
          _withDirectives((_openBlock(), _createBlock(_component_el_button, {
            class: "remove h-auto",
            link: ""
          }, {
            default: _withCtx(() => [
              _createVNode(FontAwesomeIcon, { icon: "times" })
            ]),
            _: 1
          })), [
            [
              _directive_on_native,
              () => removeAutoTemplate(__props.template.autoTemplate.text),
              "click",
              { stop: true }
            ]
          ])
        ]))
      : (__props.template.template)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("a", null, _toDisplayString(__props.template.template.descr), 1),
            _createTextVNode(" " + _toDisplayString(_unref(previewText)), 1)
          ], 64))
        : (__props.template.mention)
          ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(CoreUiOperatorAvatar, {
                  operator: __props.template.mention,
                  "show-status": ""
                }, null, 8, ["operator"])
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("a", _hoisted_7, _toDisplayString(__props.template.mention.fio), 1),
                (_unref(OperatorAccountStore).data.value.accessRights.canViewOperatorsLogin)
                  ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                      _createTextVNode(_toDisplayString(__props.template.mention.login), 1)
                    ], 64))
                  : _createCommentVNode("", true)
              ])
            ]))
          : _createCommentVNode("", true)
  ], 2)), [
    [_directive_my_tooltip, _unref(tooltipText) ? {text: _unref(tooltipText), placement: 'left', delay: 500} : null]
  ])
}
}

})